module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-Light.a73ad14.eot";